<button
  [type]="type"
  [disabled]="disabled"
  [ngClass]="[
    disabled ? 'bg-gray-100 text-gray-400' : 'text-white bg-primary-500'
  ]"
  class="w-full h-16 my-10 rounded-lg focus:outline-none"
>
  <ng-content></ng-content>
</button>
